function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50,1.239c6.746,0,12.743,5.246,12.743,11.992c0,7.496-5.997,12.742-12.743,12.742  s-11.992-5.246-11.992-12.742C38.008,6.485,43.254,1.239,50,1.239L50,1.239z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.756,28.971H50l0,0l0,0h11.993c2.999,0,4.497,0,7.495,4.498  c2.998,3.749,6.747,12.742,8.245,19.488c1.499,6.746,2.249,8.994-3.747,12.742S58.245,71.696,50,71.696l0,0  c-8.245,0-17.988-2.249-23.984-5.997s-4.498-5.996-2.998-12.742c1.499-6.747,5.247-15.74,8.245-19.488  C33.51,28.971,35.009,28.971,38.756,28.971L38.756,28.971z M50.75,61.202h9.744c0,2.998-4.497,5.247-9.744,5.247  c-5.997,0-10.494-2.249-10.494-5.247H50.75z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50,76.756L50,76.756"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50,76.756c-9.744,0.75-14.99-5.06-19.488-5.81c-5.246-0.75-5.996,0-10.493,2.998  c-4.498,2.998-13.492,10.494-15.74,15.74c-2.999,5.247-0.75,9.744,8.244,8.995c8.994-1.5,20.237-3.748,28.481-5.997  c3.748-0.749,3.748-1.499,8.995-1.499c5.248,0,5.248,0.75,8.996,1.499c8.244,2.249,19.486,4.497,28.481,5.997  c8.994,0.749,11.243-3.748,8.244-8.995c-2.249-5.246-11.242-12.742-15.739-15.74s-5.247-3.748-10.494-2.998  C64.991,71.696,59.743,77.506,50,76.756"
});

var SvgMeditate = function SvgMeditate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "#29507d",
    height: "100%",
    width: "100%",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMeditate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meditate.93501542.svg";
export { ForwardRef as ReactComponent };